<div class="client-taxpayers-container">
  @if (!actionsView) {
  <div>
    <div class="client-taxpayers-header">
      <div>
        <h2>
          {{ "clients.client-name" | transloco: { name: client?.name } }}
          {{ 'clients.taxreturn-alias' | transloco:{taxReturnAlias}
          }}{{ "clients.s" | transloco }}
        </h2>
      </div>
      <div class="client-taxpayers-buttons">
        @if (canSyncToOneteam()) {
        <div
          class="ui basic blue button client-taxpayers-buttons-sync-oneteam"
          (click)="!syncingWithOneTeam && syncToOneteam()"
          [ngClass]="{
            loading: syncingWithOneTeam,
            disabled: isUpdateToDateWithOneTeam
          }"
        >
          <img
            class="client-taxpayers-buttons-sync-oneteam-logo"
            alt="Oneteam Logo"
            src="../../assets/oneteam.png"
          />{{ "clients.Sync-Client-To-OneTeam" | transloco }}
        </div>
        } @if (canDownloadAuthlist()) {
        <div>
          <div
            class="ui primary button"
            [attr.data-test-ref]="'create-new-taxpayer'"
            (click)="downloadAuthlist()"
          >
            {{
              "clients.download-authlist"
                | transloco: { listname: AuthlistName }
            }}
          </div>
        </div>
        }
      </div>
    </div>
    <div id="filters">
      <div class="filter-item">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            id="taxpayers-input-search"
            type="text"
            [(ngModel)]="searchText"
            (ngModelChange)="updateFilteredAssignees()"
            placeholder="Search {{ taxpayerAlias }}"
          />
        </div>
      </div>
      @if (showTaxReturnType) {
      <div class="filter-item">
        <label
          >{{ 'clients.taxreturn-alias' | transloco: {taxReturnAlias} }}
          {{ "clients.type" | transloco }}</label
        >
        <div class="ui search selection dropdown" #taxReturnTypeDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      } @if (showTaxReturnType) {
      <div class="filter-item">
        <label
          >{{ 'clients.taxreturn-alias' | transloco: {taxReturnAlias} }}
          {{ "clients.subtype" | transloco }}</label
        >
        <div class="ui search selection dropdown" #taxReturnSubTypeDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      } @if (showTaxReturnType) {
      <div class="filter-item">
        <label>{{ "clients.population" | transloco }}</label>
        <div class="ui search selection dropdown" #populationDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      } @if (filterQuestions.length > 0) { @for (questionAnswer of
      filterQuestions; track questionAnswer) {
      <div
        class="filter-item"
        [ngClass]="{ 'disable-filter': questionAnswer.answers.length === 2 }"
      >
        <app-search-dropdown
          class="app-search-dropdown"
          label="{{ questionAnswer.question.question }}"
          [formGroup]="filterQuestionsForm"
          [formCtrl]="getFormControl(questionAnswer.question.id)"
          [listOptions]="questionAnswer.answers"
          [placeholder]="placeholder"
          [unicodeIcon]="questionAnswer.unicodeIcon"
          (selectedItem)="applyFilterQuestion($event)"
        >
        </app-search-dropdown>
      </div>
      } } @if (currentBatchList.length) {
      <div class="filter-item">
        <label>{{ "clients.batches" | transloco }}</label>
        <div class="ui search selection dropdown" #batchDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      }
    </div>
    @if (filteredAssignees.length === 0) {
    <div id="no-results">
      {{ 'clients.no-tax-return-alias-s-found' | transloco: {taxReturnAlias} }}
    </div>
    }
    <app-taxpayer-list
      id="taxpayer-search-list"
      class="taxpayer-search-list"
      [assignees]="filteredAssignees"
      [isClientTaxreturnsPage]="isClientTaxreturnsPage"
      [showTaxReturnType]="true"
      [showQnrType]="showQnrType"
      [currentBatchList]="currentBatchList"
      [selectedBatchId]="selectedBatchId"
      [customFilters]="customFilterAnswers"
      [taxReturnTypeById]="taxReturnTypeById"
      [taxReturnSubTypeById]="taxReturnSubTypeById"
      [client]="client"
      (refreshRequired)="refresh()"
    ></app-taxpayer-list>
  </div>
  } @if (actionsView) {
  <div class="bulk-action-container">
    <div class="client-taxpayers-header">
      <div>
        <h2>{{ "clients.bulk-apply-actions" | transloco }}</h2>
      </div>
    </div>
    <div class="back-button" (click)="backToList()">
      {{ "clients.cancel" | transloco }}
    </div>
    <p class="bulk-apply-description">
      {{ 'clients.select-an-option-to-apply-the-action-to-the-group-of-tax-return-alias-s' | transloco: {taxReturnAlias} }}
    </p>
    @for (actionGroup of actionList; track actionGroup) {
    <div class="bulk-action-group">
      <div class="status-container">
        Status{{
          actionListOfTaxReturns[actionGroup].statuses.length > 1 ? "es" : ""
        }}: @for (status of actionListOfTaxReturns[actionGroup].statuses; track
        status) {
        <span class="status-name">
          {{ status.name + "\n" }}
        </span>
        }
      </div>
      <div class="tax-return-list-item header">
        <div class="name" title="Name" *transloco="let t">
          {{
            config.tenant === tenants.FR
              ? t("clients.taxpayer")
              : t("clients.name")
          }}
        </div>
        <div class="atlas-id" [title]="atlasIdVariable">
          {{ 'clients.atlas-id-variable' | transloco: {atlasIdVariable} }}
        </div>
        <div class="results" title="Results">
          {{ "clients.results" | transloco }}
        </div>
      </div>
      @for (tr of actionListOfTaxReturns[actionGroup].taxReturns; track tr) {
      <div class="tax-return-list-item item">
        <div class="name" title="Name">
          {{ tr.firstName }} {{ tr.lastName }}
        </div>
        <div class="atlas-id" [title]="atlasIdVariable">
          {{ tr.atlasId }}
        </div>
        <div class="results" title="Results">
          @if (getActionResultSuccess(actionResults[tr.id])) {
          <div class="loader-container-outer">
            <div class="loader-container-inner">
              <div class="ui active centered inline success"></div>
            </div>
          </div>
          } @if (getActionResultFail(actionResults[tr.id])) {
          <div class="loader-container-outer">
            <div class="loader-container-inner">
              <div class="ui active centered inline fail"></div>
            </div>
          </div>
          } @if (getActionResultPending(actionResults[tr.id])) {
          <div class="loader-container-outer">
            <div class="loader-container-inner">
              <div class="ui active centered inline loader"></div>
            </div>
          </div>
          }
          {{ getActionResultString(actionResults[tr.id]) }}
        </div>
      </div>
      }
      <div class="action-container">
        <div class="action">
          @if (!actionListOfTaxReturns[actionGroup].disabled) {
          <div class="action">
            @for (action of actionListOfTaxReturns[actionGroup].actions; track
            action) {
            <button
              [attr.data-test-ref]="'action'"
              class="action-button {{ action.id }} list-action"
              [hidden]="action.adminOnly || bulkActionInProgress"
              [title]="
                action.title ||
                (action.name !== 'Generate tax package' &&
                  action.name !== 'Generate final documents')
                  ? action.name
                  : 'Complete Preparation' || ''
              "
              (click)="
                doBulkAction(
                  action,
                  actionListOfTaxReturns[actionGroup].taxReturns,
                  actionGroup
                )
              "
            >
              {{
                action.name !== "Generate tax package" &&
                action.name !== "Generate final documents"
                  ? action.name
                  : "Complete Preparation"
              }}
            </button>
            }
          </div>
          } @if (bulkActionInProgress) {
          <div>{{ "clients.actions-are-in-progress" | transloco }}</div>
          } @if (!actionListOfTaxReturns[actionGroup].actions.length) {
          <div>
            {{
              "clients.no-actions-available-for-the-current-status" | transloco
            }}
          </div>
          } @if (actionListOfTaxReturns[actionGroup].disabled) {
          <div>
            {{
              "clients.further-actions-have-been-disabled-please-go-back-to-refresh-the-bulk-action-list"
                | transloco
            }}
            <div class="back-button" (click)="backToList()">
              {{ "clients.back" | transloco }}
            </div>
          </div>
          }
        </div>
        <app-tax-return-actions
          (refresh)="refresh($event)"
          (shouldNavigateToTaxReturn)="refresh($event)"
          (shouldNavigateFromTaxReturn)="navigateAway($event)"
          [bulk]="true"
          (bulkActionComplete)="handleSingleBulkResponse($event)"
        >
        </app-tax-return-actions>
      </div>
    </div>
    }
  </div>
  }
</div>

<ng-template
  #assigneeList
  let-assignees="assignees"
  let-title="title"
  let-success="success"
  let-movedPop="movedPop"
>
  <div class="ui accordion">
    <div class="title" [ngClass]="{ success: success, fail: !success }">
      <h4>
        <span class="ui label"
          >{{ assignees?.length }}
          {{ assignees.length > 1 ? "assignees" : "assignee" }}</span
        >
        {{ title }}
      </h4>
      <i class="chevron down icon"></i>
    </div>

    <div class="content">
      <table class="ui basic compact table">
        <thead>
          <tr>
            <th>
              {{ 'clients.entity-primary-name' | transloco: {entityPrimaryName} }}
            </th>
            <th>
              {{ 'clients.entity-secondary-name' | transloco: {entitySecondaryName} }}
            </th>
            <th>
              {{ 'clients.atlas-id-variable' | transloco: {atlasIdVariable} }}
            </th>
            @if (movedPop) {
            <th>{{ "clients.new-population-name" | transloco }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (assignee of assignees; track assignee) {
          <tr>
            <td style="width:1px;padding-right: 5rem">
              {{ assignee?.firstName }}
            </td>
            <td>{{ assignee?.lastName }}</td>
            <td>{{ assignee?.atlasId }}</td>
            @if (movedPop) {
            <td>{{ (assignee?.populations)[0]?.name }}</td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<div #oneteamSyncModal class="ui modal">
  <div class="icon modal-close close"></div>
  <h1>{{ "clients.Sync-Client-To-OneTeam" | transloco }}</h1>
  <div>
    <div class="oneteam-sync">
      {{
        oneteamSyncResponse?.errorMessages?.length
          ? ("clients.Unable-to-sync-to-OneTeam-because-of-following-reasons"
            | transloco)
          : ("clients.Successfully-synced-client-and-its-projects-with-OneTeam"
            | transloco)
      }}
    </div>
    @if (oneteamSyncResponse?.errorMessages?.length) {
    <table class="ui striped table oneteam-sync">
      <thead>
        <tr>
          <th>{{ "clients.type" | transloco }}</th>
          <th>{{ "clients.Error" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (errorObject of oneteamSyncResponse?.errorMessages; track
        errorObject) {
        <tr>
          <td>{{ errorObject?.type }}</td>
          <td>
            @if (errorObject?.projectName) {
            <div class="oneteam-sync">
              {{ "clients.ProjectName" | transloco }}:
              {{ errorObject?.projectName }}
            </div>
            }
            <div>
              {{ (errorObject?.message)[lang] || oneteamSyncResponse?.message }}
            </div>
            @if (errorObject?.tags?.length) {
            <ul class="oneteam-sync-tags">
              @for (tag of errorObject?.tags; track tag) {
              <li class="oneteam-sync">{{ tag }}</li>
              }
            </ul>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
  <div class="oneteam-sync">
    <button
      class="ui primary button background tiny"
      (click)="closeOneteamSyncModal()"
    >
      {{ "clients.Close" | transloco }}
    </button>
  </div>
</div>

@if (syncingWithOneTeam) {
<div
  class="ui active inverted dimmer"
  [ngClass]="{ dimmed: syncingWithOneTeam }"
>
  <div class="ui large text loader">{{ "clients.loading" | transloco }}</div>
</div>
}
